import { useI18n } from '../stores/I18nContext'
import './CanvasToolPalette.css'

export default function CanvasToolPalette({ tool, setTool, onReset, canReset }) {
  const { t } = useI18n()

  const selectLabel = t('canvas.tools.select')
  const panLabel = t('canvas.tools.pan')
  const resetLabel = t('canvas.tools.reset')

  return (
    <div className="canvas-tool-palette" role="toolbar" aria-label={selectLabel}>
      <button
        type="button"
        className={`canvas-tool-btn ${tool === 'select' ? 'active' : ''}`}
        onClick={() => setTool('select')}
        title={selectLabel}
        aria-label={selectLabel}
        aria-pressed={tool === 'select'}
      >
        {/* Cursor / arrow icon */}
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M5 3l14 8-6 1.5L10 19 5 3z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <button
        type="button"
        className={`canvas-tool-btn ${tool === 'hand' ? 'active' : ''}`}
        onClick={() => setTool('hand')}
        title={panLabel}
        aria-label={panLabel}
        aria-pressed={tool === 'hand'}
      >
        {/* Hand icon */}
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M8 11V5.5a1.5 1.5 0 113 0V11M11 11V4.5a1.5 1.5 0 113 0V11M14 11V5.5a1.5 1.5 0 113 0V12M17 12V8.5a1.5 1.5 0 113 0V15a6 6 0 01-6 6h-1.5a5 5 0 01-3.5-1.5l-4-4a1.5 1.5 0 012.1-2.1L8 14V6.5a1.5 1.5 0 113 0"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <button
        type="button"
        className="canvas-tool-btn"
        onClick={onReset}
        disabled={!canReset}
        title={resetLabel}
        aria-label={resetLabel}
      >
        {/* Reset / recenter icon */}
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M12 4v3M12 17v3M4 12h3M17 12h3"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
          <circle
            cx="12"
            cy="12"
            r="4"
            stroke="currentColor"
            strokeWidth="1.6"
            fill="none"
          />
        </svg>
      </button>
    </div>
  )
}
